import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { logout, selectAuth, setDummyAuth } from '../store/auth/authSlice';

function NavbarLayout() {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated } = useAppSelector(selectAuth);

  const handleLogout = () => {
    // 로그아웃 후 즉시 더미 토큰으로 다시 로그인
    dispatch(logout());
    
    setTimeout(() => {
      const dummyToken = 'dummy-jwt-token-for-register-system';
      const dummyUser = {
        username: 'register-user',
        role: 'ROLE_USER'
      };

      localStorage.setItem('token', dummyToken);
      dispatch(setDummyAuth({
        user: dummyUser,
        token: dummyToken
      }));
    }, 100);
  };

  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="/">메인</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/selectall">전체목록</Nav.Link>
            <Nav.Link href="/map">지도</Nav.Link>
            <Nav.Link href="/map2">지도2</Nav.Link>
            <Nav.Link href="/map3">지도3</Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            {isAuthenticated && user && (
              <>
                <Nav.Item className="d-flex align-items-center me-3">
                  <span className="text-muted">
                    환영합니다, {user.username}님
                  </span>
                </Nav.Item>
                <Button variant="outline-secondary" size="sm" onClick={handleLogout}>
                  새로고침
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarLayout;